"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "createReporter", {
    enumerable: true,
    get: function() {
        return createReporter;
    }
});
const _logger = require("@lage-run/logger");
const _reporters = require("@lage-run/reporters");
const _workspacetools = require("workspace-tools");
const _fs = require("fs");
const _path = /*#__PURE__*/ _interop_require_default(require("path"));
const _url = require("url");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
async function createReporter(reporter, options, customReporters = {}) {
    const { verbose, grouped, logLevel: logLevelName, concurrency, profile, progress, logFile, indented } = options;
    const logLevel = _logger.LogLevel[logLevelName];
    const root = (0, _workspacetools.findPackageRoot)(__filename);
    const packageJson = JSON.parse((0, _fs.readFileSync)(_path.default.join(root, "package.json"), "utf-8"));
    const version = packageJson.version;
    switch(reporter){
        case "profile":
            return new _reporters.ChromeTraceEventsReporter({
                concurrency,
                outputFile: typeof profile === "string" ? profile : undefined
            });
        case "json":
            return new _reporters.JsonReporter({
                logLevel,
                indented: indented ?? false
            });
        case "azureDevops":
        case "adoLog":
            return new _reporters.AdoReporter({
                grouped,
                logLevel: verbose ? _logger.LogLevel.verbose : logLevel
            });
        case "npmLog":
        case "old":
            return new _reporters.LogReporter({
                grouped,
                logLevel: verbose ? _logger.LogLevel.verbose : logLevel
            });
        case "verboseFileLog":
        case "vfl":
            return new _reporters.VerboseFileLogReporter(logFile);
        default:
            // Check if it's a custom reporter defined in config
            if (customReporters && customReporters[reporter]) {
                const reporterPath = customReporters[reporter];
                const resolvedPath = _path.default.isAbsolute(reporterPath) ? reporterPath : _path.default.resolve(process.cwd(), reporterPath);
                try {
                    // Use dynamic import to load the custom reporter module
                    // This works with both ESM (.mjs, .js with type: module) and CommonJS (.cjs, .js) files
                    const reporterModule = await import((0, _url.pathToFileURL)(resolvedPath).href);
                    // Try different export patterns
                    const ReporterClass = reporterModule.default ?? reporterModule[reporter] ?? reporterModule;
                    if (typeof ReporterClass === "function") {
                        return new ReporterClass(options);
                    } else if (typeof ReporterClass === "object" && ReporterClass !== null) {
                        // If it's already an instance
                        return ReporterClass;
                    } else {
                        throw new Error(`Custom reporter "${reporter}" at "${resolvedPath}" does not export a valid reporter class or instance.`);
                    }
                } catch (error) {
                    throw new Error(`Failed to load custom reporter "${reporter}" from "${resolvedPath}": ${error}`);
                }
            }
            // Default reporter behavior
            if (progress && !(logLevel >= _logger.LogLevel.verbose || verbose || grouped)) {
                return new _reporters.ProgressReporter({
                    concurrency,
                    version
                });
            }
            return new _reporters.LogReporter({
                grouped,
                logLevel: verbose ? _logger.LogLevel.verbose : logLevel
            });
    }
}
